import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';

export function getSSOResetPasswordFormData() {
    return fetch(apiConstants.loadResetPasswordFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function handleResetPassword(userResetPasswordData, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(userResetPasswordData)
    })
        .then(handleResponse)
        .catch(handleError);
}
